import * as swcHelpers from '@swc/helpers';
import { Util } from '@grandvisionhq/forms';
import { RESET_STORE, RESET_EXPRESS_CHECKOUT, RESET_SERVICE_STORE_VALIDATION, SET_SERVICE_STORE_VALIDATION, RESET_MY_ACCOUNT_VALIDATION, SET_MY_ACCOUNT_VALIDATION, MARK_FIELDS_TOUCHED, UPDATE_SHIPPING_FORMS, UPDATE_SHIPPING_DETAILS, TOGGLE_EXPRESS_CHECKOUT, TOGGLE_INVOICE, TOGGLE_IS_COMPANY, TOGGLE_DELIVERY_ADDRESS, TOGGLE_CONSENT, SET_CONSENTS, SELECT_PICKUP_POINT, SELECT_SERVICE_STORE, SELECT_STORE, SELECT_SHIPPING_METHOD } from './actions.js';

const { markFormFieldsTouched  } = Util;
// When a form is enabled it means it's active and visible for the user
const initialFormState = {
    formData: {},
    isEnabled: true,
    isValid: false
};
const initialState = {
    selectedShippingMethod: {
        method: undefined,
        isValid: false,
        isTouched: false
    },
    isBillingAndDeliveryAddressSame: false,
    shippingDetails: {
        billingAddress: initialFormState,
        contactDetails: initialFormState,
        expressCheckout: swcHelpers.objectSpread({}, initialFormState, {
            isEnabled: false
        }),
        invoice: swcHelpers.objectSpread({}, initialFormState, {
            isEnabled: false
        }),
        deliveryAddress: swcHelpers.objectSpread({}, initialFormState, {
            isEnabled: false
        }),
        company: swcHelpers.objectSpread({}, initialFormState, {
            isEnabled: false
        })
    },
    isPrefillFinished: false,
    consents: []
};
/**
 * Handles all user interaction in the shipping step
 */ function shippingReducer(state = initialState, action) {
    switch(action.type){
        case SELECT_SHIPPING_METHOD:
            const { shippingMethod  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                selectedShippingMethod: {
                    method: shippingMethod.method,
                    isValid: shippingMethod.isValid,
                    isTouched: shippingMethod.isTouched
                }
            });
        case SELECT_STORE:
            const { store  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                selectedStore: store
            });
        case SELECT_SERVICE_STORE:
            const { serviceStore  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                serviceStore
            });
        case SELECT_PICKUP_POINT:
            const { pickupPoint  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                selectedPickupPoint: pickupPoint
            });
        case SET_CONSENTS:
            {
                const { consents  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    consents
                });
            }
        case TOGGLE_CONSENT:
            {
                const { consents  } = action.payload;
                const newConsents = state.consents.map((consent)=>swcHelpers.objectSpread({}, consent, {
                        isChecked: consents.includes(consent.value)
                    })
                );
                return swcHelpers.objectSpread({}, state, {
                    consents: newConsents
                });
            }
        case TOGGLE_DELIVERY_ADDRESS:
            {
                const { enabled  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    isBillingAndDeliveryAddressSame: !enabled,
                    shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                        deliveryAddress: swcHelpers.objectSpread({}, state.shippingDetails.deliveryAddress, {
                            isEnabled: enabled
                        })
                    })
                });
            }
        case TOGGLE_IS_COMPANY:
            {
                const { enabled  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                        company: swcHelpers.objectSpread({}, state.shippingDetails.company, {
                            isEnabled: enabled
                        })
                    })
                });
            }
        case TOGGLE_INVOICE:
            {
                const { enabled  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                        invoice: swcHelpers.objectSpread({}, state.shippingDetails.invoice, {
                            isEnabled: enabled
                        })
                    })
                });
            }
        case TOGGLE_EXPRESS_CHECKOUT:
            {
                const { enabled  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                        expressCheckout: swcHelpers.objectSpread({}, state.shippingDetails.expressCheckout, {
                            isEnabled: enabled
                        })
                    })
                });
            }
        case UPDATE_SHIPPING_DETAILS:
            const { formName , formState , formValid  } = action.payload.form;
            return swcHelpers.objectSpread({}, state, {
                shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                    [formName]: swcHelpers.objectSpread({}, state.shippingDetails[formName], {
                        formData: swcHelpers.objectSpread({}, formState),
                        isValid: formValid
                    })
                })
            });
        case UPDATE_SHIPPING_FORMS:
            return swcHelpers.objectSpread({}, state, {
                isPrefillFinished: true,
                shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                    billingAddress: swcHelpers.objectSpread({}, state.shippingDetails.billingAddress, action.payload.billingAddress),
                    deliveryAddress: swcHelpers.objectSpread({}, state.shippingDetails.deliveryAddress, action.payload.deliveryAddress),
                    contactDetails: swcHelpers.objectSpread({}, state.shippingDetails.contactDetails, action.payload.contactDetails),
                    invoice: swcHelpers.objectSpread({}, state.shippingDetails.invoice, action.payload.invoice),
                    expressCheckout: swcHelpers.objectSpread({}, state.shippingDetails.expressCheckout, action.payload.expressCheckout)
                })
            });
        case MARK_FIELDS_TOUCHED:
            {
                return swcHelpers.objectSpread({}, state, {
                    selectedShippingMethod: swcHelpers.objectSpread({}, state.selectedShippingMethod, {
                        isTouched: true
                    }),
                    shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                        deliveryAddress: swcHelpers.objectSpread({}, state.shippingDetails.deliveryAddress, {
                            formData: markFormFieldsTouched(state.shippingDetails.deliveryAddress.formData)
                        }),
                        billingAddress: swcHelpers.objectSpread({}, state.shippingDetails.billingAddress, {
                            formData: markFormFieldsTouched(state.shippingDetails.billingAddress.formData)
                        }),
                        contactDetails: swcHelpers.objectSpread({}, state.shippingDetails.contactDetails, {
                            formData: markFormFieldsTouched(state.shippingDetails.contactDetails.formData)
                        }),
                        invoice: swcHelpers.objectSpread({}, state.shippingDetails.invoice, {
                            formData: markFormFieldsTouched(state.shippingDetails.invoice.formData)
                        }),
                        company: swcHelpers.objectSpread({}, state.shippingDetails.company, {
                            formData: markFormFieldsTouched(state.shippingDetails.company.formData)
                        }),
                        expressCheckout: swcHelpers.objectSpread({}, state.shippingDetails.expressCheckout, {
                            formData: markFormFieldsTouched(state.shippingDetails.expressCheckout.formData)
                        })
                    }),
                    consents: state.consents.map((consent)=>swcHelpers.objectSpread({}, consent, {
                            shouldValidate: !!consent.required
                        })
                    )
                });
            }
        case SET_MY_ACCOUNT_VALIDATION:
            {
                return swcHelpers.objectSpread({}, state, {
                    shouldValidateMyAccount: true
                });
            }
        case RESET_MY_ACCOUNT_VALIDATION:
            {
                return swcHelpers.objectSpread({}, state, {
                    shouldValidateMyAccount: false
                });
            }
        case SET_SERVICE_STORE_VALIDATION:
            {
                return swcHelpers.objectSpread({}, state, {
                    shouldValidateServiceStore: true
                });
            }
        case RESET_SERVICE_STORE_VALIDATION:
            {
                return swcHelpers.objectSpread({}, state, {
                    shouldValidateServiceStore: false
                });
            }
        case RESET_EXPRESS_CHECKOUT:
            {
                return swcHelpers.objectSpread({}, state, {
                    selectedShippingMethod: {
                        method: undefined,
                        isValid: false,
                        isTouched: false
                    },
                    shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                        expressCheckout: swcHelpers.objectSpread({}, initialFormState, {
                            isEnabled: false
                        })
                    }),
                    consents: []
                });
            }
        case RESET_STORE:
            {
                return swcHelpers.objectSpread({}, state, {
                    selectedStore: undefined,
                    serviceStore: undefined
                });
            }
        default:
            return state;
    }
}

export { shippingReducer as default, initialFormState, initialState };
//# sourceMappingURL=reducer.js.map
